import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, ElementRef,
    Host, HostBinding,
    OnDestroy, OnInit, Optional, SkipSelf, ViewContainerRef
} from '@angular/core';

import {FormControl} from '../models/FormControl';

import _ from 'lodash';

import {FormControlState} from '../interfaces/Form';
import {FormFieldComponent} from './form-field.component';


@Component({
    selector: 'form-label',
    template: `
        {{label}}
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormLabelComponent implements OnInit, AfterViewInit, OnDestroy {
    
    /**
     * @description
     * The parent  for the containers
     *
     * @internal
     */
    _parent: FormFieldComponent;
    
    // @HostBinding(`[class.${this.name ? this.name : ''}]`) formFieldName = true
    
    get label(): string {
        
        const props = (<FormControlState>this._control.state).props;

        return (props && props.label) ? props.label : _.startCase(this._parent.name);
        
    }
    
    private get _control(): FormControl {
        return this._parent.control;
    };
    
    constructor(
            private cd: ChangeDetectorRef,
            private _elementRef: ElementRef,
            private _vcRef: ViewContainerRef,
            @Optional() @Host() @SkipSelf() parent: FormFieldComponent
    ) {
        
        this._parent = parent;
        
    }
    
    ngOnInit(): void {
    
    }
    
    ngAfterViewInit(): void {
    
    }
    
    
    ngOnDestroy(): void {
        this.cd.detach();
    }
}
